import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// CargoFL ShadCN Library — Badge.
const badgeVariants = cva(
  "inline-flex items-center whitespace-nowrap rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-1 focus:ring-ring",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-success text-success-foreground hover:bg-success/80",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        // Soft (tinted-bg + saturated-text) pill variants — used for status/sentiment
        // badges to match the Frontline prototype. Info = blue "In Progress".
        info: "border-transparent bg-[hsl(217_91%_60%/0.14)] text-[hsl(217_80%_45%)]",
        "soft-success":
          "border-transparent bg-[hsl(160_84%_39%/0.13)] text-[hsl(160_84%_26%)]",
        "soft-destructive":
          "border-transparent bg-[hsl(0_84%_60%/0.13)] text-[hsl(0_70%_45%)]",
        "soft-warning":
          "border-transparent bg-[hsl(43_74%_49%/0.16)] text-[hsl(38_70%_34%)]",
        "soft-muted":
          "border-transparent bg-[hsl(210_4%_90%)] text-[hsl(210_4%_40%)]",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
